/**
 * Vocabolario dei KPI del portale (STD-6). Gli eventi vanno a POST /usage/events di agent-runtime con app «qa». Metadata:
 * solo etichette e numeri, mai nomi, clienti, fornitori, importi o testi. Il beacon del frontend e le metriche di esito
 * li completa QA26-F5 (N4); gli eventi di dominio li manda il backend dalle rotte.
 */
import { z } from "zod";

export const USAGE_APP = "qa";

/** Viste della SPA (lista chiusa). */
export const VISTE = ["home", "redflag", "segnalazioni", "segnalazione", "nc", "report", "claim", "fornitore", "proposte", "admin"] as const;
export type Vista = (typeof VISTE)[number];

export const BeaconIn = z.discriminatedUnion("evento", [
  z.object({ evento: z.literal("portal_opened") }),
  z.object({ evento: z.literal("qa_view_opened"), view: z.enum(VISTE) }),
  z.object({ evento: z.literal("guide_opened") }),
  z.object({ evento: z.literal("onboarding_completed"), version: z.number().int().min(1).max(99), skipped: z.boolean() }),
  z.object({ evento: z.literal("tip_dismissed"), anchor: z.string().regex(/^[a-z0-9.-]{1,40}$/) }),
  z.object({ evento: z.literal("assistant_opened"), source: z.enum(["guide", "tip", "button"]) }),
  // Feedback sul portale (FBK26-F6.4, feedback-kit): stessi nomi e proprietà di @brandart/analytics-contract. Mai il testo né l'immagine.
  z.object({ evento: z.literal("feedback_mode_opened"), entry: z.enum(["button", "shortcut", "app"]) }),
  z.object({
    evento: z.literal("feedback_submitted"),
    kind: z.string().regex(/^[a-z_]{1,30}$/),
    anchor_mode: z.enum(["area", "point", "page"]),
    has_image: z.boolean(),
    masked_count: z.number().int().min(0).max(10_000),
  }),
  z.object({ evento: z.literal("feedback_cancelled"), step: z.enum(["selezione", "commento", "anteprima"]) }),
  z.object({ evento: z.literal("feedback_status_viewed"), unseen: z.number().int().min(0).max(1000) }),
]);
export type BeaconIn = z.infer<typeof BeaconIn>;

/** Eventi di dominio, dal backend. */
export const EVENTI_DOMINIO = [
  "segnalazione_created",
  "segnalazione_updated",
  "classificazione_proposed",
  "proposta_decided",
  "nc_opened",
  "nc_updated",
  "nc_closed",
  "claim_created",
  "claim_updated",
  "report_viewed",
  "export_downloaded",
  "import_run",
] as const;
export type EventoDominio = (typeof EVENTI_DOMINIO)[number];

/**
 * Metriche di esito (STD-6, famiglia «esito»): istantanea giornaliera `qa_outcome_snapshot` dal backend
 * (backend/src/services/esiti.ts), solo conteggi, giorni e percentuali.
 */
export const EVENTO_ESITI = "qa_outcome_snapshot";
export const METRICHE_ESITO = [
  "nc_aperte",
  "nc_con_owner_scadenza",
  "azioni_scadute",
  "classificate_90g",
  "classificazione_giorni_mediana",
  "claim",
  "recupero_claim_ratio",
] as const;
export type MetricaEsito = (typeof METRICHE_ESITO)[number];
